import React from "react";
import { Row, Typography } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface PlaceHolderDashedProps {
  wording: string;
}
const PlaceHolderDashed: React.FC<PlaceHolderDashedProps> = ({ wording }) => {
  return (
    <Row justify={"center"} align={"middle"} className="w-24 border-dashed border-2 rounded">
      <PlusCircleOutlined />
      <Text type="secondary" className="pl-2" style={{ fontSize: 12 }}>
        {wording}
      </Text>
    </Row>
  );
};

export default PlaceHolderDashed;
